<template>
  <div class="withdraw-password-page">
    <CustomHeader
      :text="$t('withdrawPassword.title')"
      :is-popup-close-back-icon="true"
      @close-popup="backNavigate"
      :show-fund="false"
      @go-to-fund="goToFund"
    />

    <div class="content">

      <div class="title">{{ $t('withdrawPassword.configTitle') }}</div>

      <div class="label">{{ $t('withdrawPassword.newPassword') }}</div>
      <div class="input-row">
        <input
          v-for="(item,index) in newPassword"
          :key="'new'+index"
          ref="newInputs"
          maxlength="1"
          type="password"
          class="box"
          :value="item"
          @input="handleNewInput($event,index)"
          @keydown="handleNewBackspace($event,index)"
        />
      </div>

      <div class="label">{{ $t('withdrawPassword.confirmPassword') }}</div>
      <div class="input-row">
        <input
          v-for="(item,index) in confirmPassword"
          :key="'confirm'+index"
          ref="confirmInputs"
          maxlength="1"
          type="password"
          class="box"
          :value="item"
          @input="handleConfirmInput($event,index)"
          @keydown="handleConfirmBackspace($event,index)"
        />
      </div>

      <div class="info">
        {{ $t('withdrawPassword.firstWithdrawTip') }}
      </div>

      <div class="btn_container">
        <MainButton
          :title="$t('withdrawPassword.withdrawNow')"
          :activeStatus="isFillField"
          @click="confirmWithdraw"
          :radius="'10'"
        />
      </div>

    </div>

  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'

import CustomHeader from '../components/common/customHeader.vue'
import MainButton from '../../themeThree/components/common/mainButton.vue'

const router = useRouter()
const userStore = useUserStore()

const newPassword = ref(['','','','','',''])
const confirmPassword = ref(['','','','','',''])

const newInputs = ref<HTMLInputElement[]>([])
const confirmInputs = ref<HTMLInputElement[]>([])

const handleNewInput = (e:any,index:number)=>{
  const value = e.target.value
  if(!/^[0-9]?$/.test(value)){
    e.target.value=''
    return
  }

  newPassword.value[index]=value

  if(value && index < 5){
    newInputs.value[index+1].focus()
  }
}

const handleConfirmInput = (e:any,index:number)=>{
  const value = e.target.value
  if(!/^[0-9]?$/.test(value)){
    e.target.value=''
    return
  }

  confirmPassword.value[index]=value

  if(value && index < 5){
    confirmInputs.value[index+1].focus()
  }
}

const handleNewBackspace = (e:any,index:number)=>{
  if(e.key==='Backspace' && !newPassword.value[index] && index>0){
    newInputs.value[index-1].focus()
  }
}

const handleConfirmBackspace = (e:any,index:number)=>{
  if(e.key==='Backspace' && !confirmPassword.value[index] && index>0){
    confirmInputs.value[index-1].focus()
  }
}

const isFillField = computed(()=>{
  return newPassword.value.every(v=>v!=='') &&
         confirmPassword.value.every(v=>v!=='')
})

const confirmWithdraw = ()=>{
  const pass1 = newPassword.value.join('')
  const pass2 = confirmPassword.value.join('')

  if(pass1 !== pass2){
    alert('Password not match')
    return
  }

}

const backNavigate = () => {
  userStore.setRechargeBonusType(0)
  userStore.setTakeFirstDeposit(false)
  router.go(-1)
}

const goToFund = () => {
  router.replace({ path: '/fundsHistory', query: { tabIndex: 0 } })
}
</script>

<style scoped>

.withdraw-password-page{
  min-height:100vh;
  background:linear-gradient(180deg,#04142d,#020c1a);
  color:#fff;
}

.content{
  padding:24px;
}

.title{
  font-size:20px;
  font-weight:600;
  margin-bottom:20px;
}

.label{
  font-size:14px;
  margin-bottom:10px;
  color:#cfd7e3;
}

.input-row {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  margin-bottom: 20px;
}

.box{
  width:48px;
  height:48px;
  border-radius:8px;
  border:none;
  outline:none;
  background:#1c2a47;
  text-align:center;
  font-size:20px;
  color:#fff;
}

.box:focus{
  border:1px solid #2e8cff;
}

.info{
  font-size:13px;
  color:#8e9bb3;
}

.btn-area{
  margin-top:40px;
  width:100%;
  display:flex;
  justify-content:center;
}

.btn-area :deep(.main-button){
  width:240px;
  height:40px;
}

.btn_container {
    padding: 40px 10%;
}

/* @media (max-width: 400px) {
  .input-row {
    gap: 6px;
  }

  .box {
    height: 45px;
    width: 45px;
    font-size: 18px;
  }
} */

</style>